import { render } from "./pagination-entries.vue?vue&type=template&id=7f434732"
import script from "./pagination-entries.vue?vue&type=script&lang=js"
export * from "./pagination-entries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__